import { cx } from "@emotion/css";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Box from "src/components/Default/Main/Box";
import { Header } from "src/components/Main/ExamsBox/ExamsBox";
import { Modal } from "src/components/Modals/Components/ModalsComponents";
import { CourseSectionStatistics } from "src/components/Statistics/courseSection/CourseSectionStatistics";
import { ExamDepartmentsStatistics } from "src/components/Statistics/exam/ExamDepartmentsStatistics";
import { useGetExamsStats } from "src/hooks/useExam";
import ChartIcon from "src/images/Icons/newIcons/chart.svg";

interface ExamsStatisticsModalProps {
	examsIds: string[];
	onClose: () => void;
}

export const ExamsStatisticsModal = ({ examsIds, onClose }: ExamsStatisticsModalProps) => {
	const { data: stats, isLoading } = useGetExamsStats(examsIds);

	const { t } = useTranslation();
	const [selectedTab, setSelectedTab] = useState(0);

	const renderContent = () => {
		if (selectedTab === 0) {
			return <CourseSectionStatistics stats={stats} />;
		}

		if (selectedTab === 1) {
			return <ExamDepartmentsStatistics stats={stats.departmentsStats} />;
		}
	};

	return (
		<Modal open onClose={onClose} isLoading={isLoading}>
			<Box
				className="exam-statistics-modal"
				tabs={[
					t("modals.statistics.tabs.sectionInfo"),
					t("modals.statistics.tabs.sectionStats"),
				]}
				onTabsChange={setSelectedTab}
				selectedTab={selectedTab}
				Header={
					<Header
						title={t("modals.statistics.title")}
						icon={<ChartIcon className={cx("icon-big icon-primary")} />}
					/>
				}
			>
				<div>
					<div className="border-light-grey mb-16"></div>
				</div>
				<div>{renderContent()}</div>
			</Box>
		</Modal>
	);
};
